export const INTEGRATION_MRN = "integrationMrn";
export const TRANSITION_SPEED = "transform 325ms";

import { ClientIntegrationType, IntegrationType } from "~/operations";

// Ticketing systems should only show the total count
export const ticketingIntegrationTypes: Array<
  ClientIntegrationType | IntegrationType
> = [
  IntegrationType.TicketSystemEmail,
  IntegrationType.TicketSystemJira,
  IntegrationType.TicketSystemGithub,
  IntegrationType.TicketSystemGitlab,
  IntegrationType.TicketSystemZendesk,
  IntegrationType.TicketSystemAzureDevops,
  IntegrationType.TicketSystemWebhook,
  IntegrationType.TicketSystemServiceNow,
];

export const thirdPartyImportIntegrationTypes: Array<
  ClientIntegrationType | IntegrationType
> = [
  IntegrationType.MicrosoftDefender,
  IntegrationType.SentinelOne,
  IntegrationType.CrowdstrikeFalcon,
];

export const securityPipelineIntegrationTypes: Array<
  ClientIntegrationType | IntegrationType
> = [IntegrationType.SecurityPipelineGithub];
